export default __webpack_public_path__ + "static/media/README.24f949b9.md";